/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{26CAB3B6-7FAE-440E-8FC5-688B1502224F}",
  "sitecoreApiHost": "https://www.cochlear.com",
  "jssAppName": "support",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/support",
  "graphQLEndpoint": "https://www.cochlear.com/api/support?sc_apikey={26CAB3B6-7FAE-440E-8FC5-688B1502224F}"
};